import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';

const { FiRadio, FiFilter, FiHeart, FiTrendingUp } = FiIcons;

const steps = [
  {
    icon: FiRadio,
    label: 'Attract',
    color: 'from-[#8cc63f] to-[#a8d85a]',
    title: 'Get Found & Attract Leads',
    desc: "You can't get clients if they don't know your cleaning business exists. Getting leads is the #1 factor when building your cleaning business. Being everywhere you can possibly afford to be and positioning yourself as the authority in your market is the goal here.",
  },
  {
    icon: FiFilter,
    label: 'Convert',
    color: 'from-[#7ab535] to-[#8cc63f]',
    title: 'Convert Leads Into Clients',
    desc: "Converting those leads and filling your funnel is your goal here. Having a high-converting site and dedicated landing pages will help you get those cleaning clients and fill your funnel with potential clients during all different times of the buyer's cycle.",
  },
  {
    icon: FiHeart,
    label: 'Nurture',
    color: 'from-[#6aaa25] to-[#7ab535]',
    title: 'Nurture With Automation',
    desc: "Now that you've attracted the leads and converted them into your funnel, it's time to nurture them. People come into the funnel during all different times of the buying cycle — stay in front of them with marketing automation and re-marketing.",
  },
  {
    icon: FiTrendingUp,
    label: 'Grow',
    color: 'from-[#5a9a15] to-[#6aaa25]',
    title: 'Grow & Scale Your Business',
    desc: "This is where your brand has done its job. Your cleaning services are firing on all cylinders, you're fine-tuning your processes, you can close leads, and your marketing is keeping those leads flowing in consistently.",
  },
];

const Roadmap = () => {
  return (
    <section id="roadmap" className="py-24 md:py-32 bg-[#4b4b4b]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center mb-20">
          <motion.span
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            className="text-[#8cc63f] font-semibold text-sm uppercase tracking-widest"
          >
            Your Strategy
          </motion.span>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-3xl md:text-5xl font-bold text-white mt-3 mb-5 tracking-tight"
          >
            Your Cleaning Business <br className="hidden md:block" />Marketing Road Map
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
            className="text-gray-300 max-w-xl mx-auto text-lg"
          >
            A proven 4-phase framework to attract, convert, nurture, and grow your cleaning business.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((step, idx) => (
            <motion.div
              key={idx}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: idx * 0.15 }}
              className="relative group"
            >
              <div className="bg-white/5 border border-white/10 rounded-2xl p-8 h-full hover:bg-white/10 transition-all duration-300">
                <div className={`w-14 h-14 rounded-2xl bg-gradient-to-br ${step.color} flex items-center justify-center mb-5 shadow-lg group-hover:scale-110 transition-transform duration-300`}>
                  <step.icon className="text-white text-2xl" />
                </div>
                <span className="text-xs font-black uppercase tracking-widest text-[#8cc63f] mb-2 block">
                  Phase {idx + 1} — {step.label}
                </span>
                <h3 className="text-lg font-bold text-white mb-3">{step.title}</h3>
                <p className="text-gray-300/80 text-sm leading-relaxed">{step.desc}</p>
              </div>
              {idx < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-3 z-10 w-6 h-0.5 bg-[#8cc63f]/40" />
              )}
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mt-14 text-center"
        >
          <a
            href="#strategy"
            className="inline-flex items-center gap-2 px-8 py-4 bg-[#8cc63f] hover:bg-[#7ab535] text-white font-bold rounded-full transition-all shadow-xl shadow-black/30 text-lg"
          >
            Get Started Here — For Maximum Leads & Profitability
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default Roadmap;